import React, { Component } from 'react';
import { connect } from 'react-redux';
import { domainActions } from '../../_actions';
import { Loader } from '../../_components';
import { SimpleFetch, SimpleFetchResponse } from '../../_helpers';

import { DomainBlockComponent, DomainRegistrationComponent } from './_components';

import 'react-toastify/dist/ReactToastify.css';
import './Domains.scss';

class DomainsContainer extends Component {
  constructor(props){
    super(props);

    this.state = {
      domains: [],
      count: 0,
      isLoading: true,
      isEmpty: false,
      geroVersions: [],
      cnswVersions: []
    }

    this.addDomain = React.createRef();
    this.reloadDomains = React.createRef();
    this.handleDomainReload = this.handleDomainReload.bind(this);
  }

  async componentWillMount(){
    document.title = 'Domains - Cellit.io';

    let _ = this;
    const { dispatch } = this.props;

    dispatch(domainActions.getDomainsByToken())
    .then(res => {
      if ( res.type === 'VERIFY_DOMAIN_FAILURE' ) return;

      if ( res.data.data.length === 0 ) {
        _.addDomain.current.click();
        return this.setState({isLoading: false, isEmpty: true});
      }

        _.reloadDomains.current.click();
      });

    const geroReq = await SimpleFetch(`GET`, {}, {}, `main`, `gero/version/list`)
    if ( geroReq.status !== 200 )
      return SimpleFetchResponse(geroReq, "Não foi possível listar as versões do Gero. Tente novamente mais tarde.", "Versões indisponíveis.");
    
    const cnswReq = await SimpleFetch(`GET`, {}, {}, `main`, `cnsw/version/list`)
    if ( cnswReq.status !== 200 )
      return SimpleFetchResponse(cnswReq, "Não foi possível listar as versões do CNSW. Tente novamente mais tarde.", "Versões indisponíveis.");

    this.setState({
      geroVersions: geroReq.data.map(gr => {return {label: gr.version, value: gr.version}}),
      cnswVersions: cnswReq.data.map(cn => {return {label: cn.version, value: cn.version}}),
      isLoading: false
    });
  }

  componentDidMount(){
    if( !sessionStorage.getItem('cellit_domains')) return;

    let infoDomains = JSON.parse(sessionStorage.getItem('cellit_domains'));

    this.setState(prevState => ({
      domains: [...prevState.domains, infoDomains]
    }));
  }

  handleDomainReload(e, shouldRedoRequest) {
    if ( !e && shouldRedoRequest && this.state.isEmpty ) {
      let _ = this;
      const { dispatch } = this.props;

      return dispatch(domainActions.getDomainsByToken())
        .then(res => {
          if ( res.type === 'VERIFY_DOMAIN_FAILURE' ) return;

          if ( res.data.data.length === 0 ) {
            _.addDomain.current.click();
            return this.setState({isLoading: false, isEmpty: true});
          }

            _.reloadDomains.current.click();
            this.setState({isLoading: false, isEmpty: false});
          });
    }
    
    this.setState({domains: JSON.parse(sessionStorage.getItem('cellit_domains'))});
  }

  render(){
    return(
      <section className="component component-domains">
        <div className="mobile-buttons-group hidden-lg visible-xs">
          <button type="button" className="btn btn-blue is-rounded" data-toggle="modal" data-target="#domainRegistrationModal">
            <i className="lnr lnr-plus-circle"></i>
          </button>
        </div>

        <div className="component-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <h1 className="title">Domínios</h1>
              </div>
              <div className="col hidden-xs visible-lg">
                <button type="button" className="btn btn-white float-right add-domain-btn" data-toggle="modal" data-target="#domainRegistrationModal"><i className="linearicons-plus-circle" ref={this.addDomain}></i> Adicionar domínio</button>
                <button type="button" ref={this.reloadDomains} id="reload-domains" style={{display: 'none'}} className="btn btn-white-outlined float-right" onClick={this.handleDomainReload}>Recarregar domínios</button>
              </div>
            </div>
          </div>
        </div>
        <div className="component-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                {
                  this.state.isEmpty ?
                    <h2 className="empty-disclaimer">Clique no botão no canto superior direito para adicionar um novo domínio e começar a utilizar todas as funcionalidades da Plataforma Cellit.</h2>
                  : !this.state.isLoading && this.state.domains && this.state.domains.length !== 0 ?
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Nº</th>
                            <th>Nome</th>
                            <th>Domínio</th>
                            <th>Status</th>
                            <th>Versão Gero</th>
                            <th>Versão CNSW</th>
                            <th>Script</th>
                            <th>Opções</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            this.state.domains.map((domain, index) => {
                              return <DomainBlockComponent key={index++} count={index++} {...domain} geroVersions={this.state.geroVersions} cnswVersions={this.state.cnswVersions}/>
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  : <Loader />
                }
              </div>
            </div>
          </div>
        </div>

        <DomainRegistrationComponent handleDomainReload={this.handleDomainReload} reloadSidebar={this.props.reloadSidebar} />
      </section>
    )
  }
}

function mapStateToProps(state) {
  const { domains } = state.listDomainsReducer;
  return domains;
}

const ConnectedDomainsContainer = connect(mapStateToProps)(DomainsContainer);
export { ConnectedDomainsContainer as DomainContainer };
